// Computer Player Interface
class ComputerPlayer {
  /**
   * Makes a move for the computer player.
   * Subclasses should override this method with game-specific logic.
   * @param {Array} board - Current game board state
   * @param {number|string} player - Identifier for the current player
   * @returns {*} - Move decision; return null if no valid move exists
   */
  makeMove(board, player) {
    return null;
  }
}

export default ComputerPlayer;
